import { render, staticRenderFns } from "./ReportMetadataTable.vue?vue&type=template&id=5a0bf4ba&"
import script from "./ReportMetadataTable.vue?vue&type=script&lang=ts&"
export * from "./ReportMetadataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0bf4ba')) {
      api.createRecord('5a0bf4ba', component.options)
    } else {
      api.reload('5a0bf4ba', component.options)
    }
    module.hot.accept("./ReportMetadataTable.vue?vue&type=template&id=5a0bf4ba&", function () {
      api.rerender('5a0bf4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/report/metadata/ReportMetadataTable.vue"
export default component.exports